module.exports = __webpack_public_path__ + "img/old-portal-outline.d558bc40.svg";